import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { api } from '../../../utility/api';
import axios from 'axios';

const initialState = {
  isAuthenticated: false,
  loading: false,
  error: null
};

export const login = createAsyncThunk(
  "admin/login",
  async (formData, { rejectWithValue }) => {
    try {
      const response = await api.post("/admin/login", formData);
      
      if (response.data.token) {
        localStorage.setItem("authToken", response.data.token);
        return response.data;
      } else {
        return rejectWithValue('No token received from server');
      }
    } catch (error) {
      console.error('Login error:', error.response?.data); // Debug log
      return rejectWithValue(error.response?.data?.message || 'Login failed');
    }
  }
);

const adminSlice = createSlice({
  name: 'admin',
  initialState,
  reducers: {
    logout: (state) => {
      state.isAuthenticated = false;
      localStorage.removeItem('authToken');
    },
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    setError: (state, action) => {
      state.error = action.payload;
    },
    loginSuccess: (state) => {
      state.isAuthenticated = true;
      state.error = null;
    },
    logoutSuccess: (state) => {
      state.isAuthenticated = false;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(login.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(login.fulfilled, (state) => {
        state.loading = false;
        state.isAuthenticated = true;
      })
      .addCase(login.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  }
});

// Actions
export const { logout, setLoading, setError, loginSuccess, logoutSuccess } = adminSlice.actions;

// Thunks
export const checkAuth = () => async (dispatch) => {
  try {
    dispatch(setLoading(true));
    const token = localStorage.getItem('authToken');
    
    if (token) {
      dispatch(loginSuccess());
    } else {
      dispatch(logoutSuccess());
    }
  } catch (error) {
    dispatch(logoutSuccess());
  } finally {
    dispatch(setLoading(false));
  }
};

export default adminSlice.reducer; 